import { useState, useEffect } from 'react';
import { useReducedMotion } from 'framer-motion';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { FadeInImage } from 'root/src/client/v2/_pages/drops/redesign/FadeInImage';
import { Img } from 'root/src/client/v2/common/components/ui/image';
const CYCLE_MS = 1400;
// Cross-fades through the drop's images while the card is hovered. Single-image drops just
// show the one image with the standard fade-in. Scale-on-hover comes from the parent group.
export const CardImageGallery = ({ images, alt, hovering }) => {
    const reduceMotion = useReducedMotion();
    const [active, setActive] = useState(0);
    useEffect(() => {
        if (!hovering || reduceMotion || images.length <= 1) {
            return undefined;
        }
        const timer = setInterval(() => setActive(value => (value + 1) % images.length), CYCLE_MS);
        return () => clearInterval(timer);
    }, [hovering, reduceMotion, images.length]);
    useEffect(() => {
        if (!hovering) {
            setActive(0);
        }
    }, [hovering]);
    // Only the first image is mounted until the card is hovered. An `opacity-0` sibling is still laid
    // out with a resolved `src`, so the browser fetched every gallery image of every card on the grid's
    // first paint, and `loading="lazy"` does not help the cards that are already in the viewport. A
    // twelve-card grid with four images each meant ~48 requests to show 12 pictures. Once mounted they
    // stay mounted, so re-hovering the same card never reloads.
    const [mountedCount, setMountedCount] = useState(1);
    useEffect(() => {
        if (hovering) {
            setMountedCount(images.length);
        }
    }, [hovering, images.length]);
    if (!images.length) {
        return <div className="h-full w-full bg-secondary"/>;
    }
    if (images.length === 1) {
        return <FadeInImage src={images[0]} alt={alt} className="h-full w-full object-cover group-hover:scale-105"/>;
    }
    return (<div className="relative h-full w-full transition-transform duration-500 group-hover:scale-105">
			{images.slice(0, mountedCount).map((src, index) => (<Img key={src} src={src} alt={alt} loading="lazy" className={cn('absolute inset-0 h-full w-full object-cover transition-opacity duration-500', index === active ? 'opacity-100' : 'opacity-0')}/>))}
		</div>);
};
